module.exports = __webpack_public_path__ + "static/img/30015 (1).e3771aa.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30015 (1).webp
// module id = WqV6
// module chunks = 14